import { Avatar, Drawer, List, Stack, Toolbar } from '@mui/material';
import assets from '../../assets';
import sizeConfigs from '../../utils/sizeConfigs';
import appRoutes from '../../routes/AdminRouter/appRoutes';
import SidebarItem from '../SidebarItem/SidebarItem';
import SidebarItemCollapse from '../SidebarItemCollapse/SidebarItemCollapse';
import React, { useEffect, useRef, useState } from 'react';
import { colorConfigs, colors } from 'utils/colors';
// import { useScreenSize } from 'utils/helpers';
import { ContainerMenuNav, ListMenu, MobileMenu } from './SideBar.style';
import MenuIcon from '@mui/icons-material/Menu';

const Sidebar = () => {
  function isMobileNavigation(): boolean {
    const userAgent = navigator.userAgent;
    const mobileKeywords = [
      'Mobi', // Smartphones em geral
      'Android', // Dispositivos Android
      'iPhone', // iPhones
      'iPad', // iPads
      'Windows Phone', // Windows Phones
    ];

    return mobileKeywords.some((keyword) => userAgent.includes(keyword));
  }

  const isResponsive = isMobileNavigation() ? true : window.innerWidth < 769;
  const headerRef = useRef<HTMLDivElement>(null);
  const [actieMenu, setActiveMenu] = useState<boolean>(false);

  const handleClickOutside = (event: MouseEvent) => {
    if (headerRef.current && !headerRef.current.contains(event.target as Node)) {
      setActiveMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  function handleMenuActive() {
    if (actieMenu) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: isResponsive ? '100%' : sizeConfigs.sidebar.width,
        height: isResponsive ? '80px' : '100vh',
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: isResponsive ? '100%' : sizeConfigs.sidebar.width,
          boxSizing: 'border-box',
          height: isResponsive ? '80px' : '100%',
          borderRight: '0px',
          backgroundColor: colorConfigs.sidebar.bg,
          color: colorConfigs.sidebar.color,
        },
      }}
    >
      <List disablePadding>
        {!isResponsive && (
          <Toolbar sx={{ marginBottom: '20px' }}>
            <Stack sx={{ width: '100%' }} direction="row" justifyContent="center">
              <Avatar
                src={assets.images.logoSidebar}
                sx={{
                  borderRadius: '0px',
                  width: '110px',
                  marginTop: '30px',
                  height: '60px',
                  objectFit: 'contain',
                }}
              />
            </Stack>
          </Toolbar>
        )}
        <MobileMenu style={{ zIndex: actieMenu ? '-1' : 0 }}>
          <MenuIcon onClick={handleMenuActive} />
          <Stack direction="row" justifyContent="center">
            <Avatar
              src={assets.images.logoSidebar}
              sx={{
                borderRadius: '0px',
                width: '110px',
                height: '60px',
                objectFit: 'contain',
              }}
            />
          </Stack>
        </MobileMenu>

        {!isResponsive &&
          appRoutes.map((route, index) =>
            route.sidebarProps ? (
              route.child ? (
                <SidebarItemCollapse item={route} key={index} />
              ) : (
                <SidebarItem item={route} key={index} />
              )
            ) : null,
          )}
      </List>
      {isResponsive && actieMenu && (
        <ContainerMenuNav ref={headerRef}>
          {appRoutes.map((route, index) =>
            route.sidebarProps ? (
              route.child ? (
                <ListMenu
                  to={route.path ? route.path : null}
                  style={({ isActive }) => {
                    return {
                      color: isActive ? colors.verde : 'unset',
                      fontWeight: isActive ? 700 : 500,
                    };
                  }}
                  key={index}
                >
                  {route.sidebarProps.displayText}
                </ListMenu>
              ) : (
                <ListMenu
                  to={route.path ? route.path : null}
                  onClick={() => setActiveMenu(false)}
                  style={({ isActive }) => {
                    return {
                      color: isActive ? colors.verde : 'unset',
                      fontWeight: isActive ? 700 : 500,
                    };
                  }}
                  key={index}
                >
                  {route.sidebarProps.displayText}
                </ListMenu>
              )
            ) : null,
          )}
        </ContainerMenuNav>
      )}
    </Drawer>
  );
};

export default Sidebar;
